import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { NotificationSocketService } from 'src/app/shared/notification-socket-service.service';

@Component({
  selector: 'app-project-list',
  templateUrl: './project-list.component.html',
  styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent {

  projects: any[] = [];
  originalProjects: any[] = [];

  page = 0;
  size = 15;
  totalPages = 0;

  constructor(
    private projectService: ProjectService,
    private router: Router,
    public socket: NotificationSocketService
  ) { }

  ngOnInit(): void {
    this.socket.connect();
    this.loadProjects();
  }

  // -----------------------------------------------------
  // Load paginated projects
  // -----------------------------------------------------
  loadProjects() {
    this.projectService.getProjectsPaged(this.page, this.size).subscribe({
      next: (res: any) => {
        const list = res.content || [];
        this.totalPages = res.totalPages;

        // Sort by creation date
        this.projects = [...list].sort(
          (a, b) =>
            new Date(b.creationDate).getTime() -
            new Date(a.creationDate).getTime()
        );

        this.originalProjects = [...this.projects];
      },
      error: (err) => console.error("Failed to load projects", err),
    });
  }

  // Pagination handlers
  nextPage() {
    if (this.page < this.totalPages - 1) {
      this.page++;
      this.loadProjects();
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.loadProjects();
    }
  }

  changeSize() {
    this.page = 0; // reset back to first page
    this.loadProjects();
  }

  // -----------------------------------------------------
  // View Project
  // -----------------------------------------------------
  viewProject(id: string) {
    this.router.navigate(["/project-details", id]);
  }


  openProjectUsers(projectId: string) {
    this.router.navigate(['/project-users', projectId]);
  }

  openProjectRoles(projectId: string) {
    this.router.navigate(['/project-roles', projectId]);
  }




}
